import './index.css';

interface PropTypes {
  children: any;
  isDesktop?: boolean;
  id?: any;
}

const HorizontalScroll = ({ children, isDesktop = false, id = '' }: PropTypes) => {
  return (
    <div
      className="horizontalScroll__wrapper"
      id={id}
      style={{
        overflowX: 'scroll',
        paddingTop: isDesktop ? '7px' : '0px',
        alignItems: 'center'
      }}>
      {children}
    </div>
  );
};

export default HorizontalScroll;
